import React, { useState } from 'react';
import { Button, FormControl, TextField } from '@mui/material';
import { getRoyaltyPaymentOtp, approveRoyaltyPayment } from '../../../helper/Api';
import { AddCommasToAmount } from '../../../helper/Utils';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import './RoyaltyPayment.css';

const RoyaltyPayment = ({ data }) => {
    const navigate = useNavigate();
    const [otp, setOtp] = useState('');
    const [initPayment, setInitPayment] = useState(false);
    const bankDetails = data?.bankDetails || {};

    const initiatePayment = async () => {
        try {
            const otpDetail = await getRoyaltyPaymentOtp();
            if (otpDetail.data.status) {
                setInitPayment(true);
                toast.success('OTP sent successfully', { position: toast.POSITION.TOP_CENTER });
            }
        } catch (e) {
            toast.error('Error while sending OTP', { position: toast.POSITION.TOP_CENTER });
        }
    };

    const handlePayNow = async () => {
        try {
            const otpDetail = await approveRoyaltyPayment({
                payment_order_no: data.payment_order_no,
                otp,
            });
            if (otpDetail.data.status) {
                toast.success('Payment approved successfully', { position: toast.POSITION.TOP_CENTER });
                setTimeout(() => navigate('/royalty_labour_approval'), 400);
                setOtp('');
                setInitPayment(false);
            } else {
                toast.error(otpDetail.data.error, { position: toast.POSITION.TOP_CENTER });
            }
        } catch (e) {
            toast.error('Error while approving payment', { position: toast.POSITION.TOP_CENTER });
        }
    };

    return (
        <div className="royalty-payment-section card p-4 mt-3">
            <div className="row">
                <div className="col-md-6 royalty-payment-bank-col">
                    <h6 className="royalty-payment-section-title">Bank Account Details</h6>
                    <div className="row">
                        <div className="col-12 mb-3">
                            <FormControl fullWidth>
                                <TextField
                                    label="Account Name"
                                    variant="outlined"
                                    value={bankDetails.project_name || ''}
                                    InputProps={{ readOnly: true }}
                                    disabled
                                    required
                                />
                            </FormControl>
                        </div>
                        <div className="col-12 mb-3">
                            <FormControl fullWidth>
                                <TextField
                                    label="Bank"
                                    variant="outlined"
                                    value={bankDetails.bank_name || ''}
                                    InputProps={{ readOnly: true }}
                                    disabled
                                    required
                                />
                            </FormControl>
                        </div>
                        <div className="col-12 mb-3">
                            <FormControl fullWidth>
                                <TextField
                                    label="Branch"
                                    variant="outlined"
                                    value={bankDetails.branch || ''}
                                    InputProps={{ readOnly: true }}
                                    disabled
                                    required
                                />
                            </FormControl>
                        </div>
                        <div className="col-12 mb-3">
                            <FormControl fullWidth>
                                <TextField
                                    label="IFSC Code"
                                    variant="outlined"
                                    value={bankDetails.ifsc_code || ''}
                                    InputProps={{ readOnly: true }}
                                    disabled
                                    required
                                />
                            </FormControl>
                        </div>
                        <div className="col-12 mb-3">
                            <FormControl fullWidth>
                                <TextField
                                    label="Account No"
                                    variant="outlined"
                                    value={bankDetails.account_no || ''}
                                    InputProps={{ readOnly: true }}
                                    disabled
                                    required
                                />
                            </FormControl>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 royalty-payment-action-col">
                    <div className="royalty-payment-amount-card">
                        <p className="royalty-payment-amount-label">Total Amount to Pay Now</p>
                        <p className="royalty-payment-amount-value">
                            ₹ {data?.amount ? AddCommasToAmount(data.amount) : '0.00'}
                        </p>
                    </div>

                    <div className="royalty-payment-actions">
                        <Button
                            variant="contained"
                            className="royalty-payment-initiate-btn"
                            onClick={initiatePayment}
                        >
                            Initiate Payment
                        </Button>

                        <FormControl fullWidth>
                            <TextField
                                label="OTP"
                                variant="outlined"
                                type="number"
                                name="otp"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                                placeholder="Enter OTP"
                                disabled={!initPayment}
                            />
                        </FormControl>

                        <Button
                            variant="contained"
                            className="royalty-payment-pay-btn"
                            disabled={!otp}
                            onClick={handlePayNow}
                        >
                            Pay Now
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RoyaltyPayment;
